if (localStorage.getItem('cookies')) {
    $('.sticky').attr('style', 'display: none !important');
} else {
    $('.sticky').removeAttr('style');
}

$(window).on('load', function () {
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
    $('.cigar').fadeOut('slow');
});

function isChrome() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (userAgent.includes("chrome"));
}

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function regenerate_register_recaptcha() {
    setInterval(function () {
        let registerForm = $('#register_form');
        let registerFormAction = registerForm.attr('action');
        let registerFormActionMain = registerFormAction.split('?token')[0];

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {


                registerForm.attr('action', registerFormActionMain + '?token=' + token);
            });
        });
    }, 60000);
}

function register_recaptcha() {
    let registerForm = $('#register_form');
    let registerFormAction = registerForm.attr('action');
    let registerFormActionMain = registerFormAction.split('?token')[0];

    grecaptcha.ready(() => {
        grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
            action: 'contact'
        }).then(token => {


            registerForm.attr('action', registerFormActionMain + '?token=' + token);
        });
    });

}

function initMap() {
    if (typeof lat !== 'undefined' && typeof lng !== 'undefined') {
        const myLatLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
        const map = new google.maps.Map(document.getElementById("map-contacts"), {
            zoom: 17,
            center: myLatLng
        });

        new google.maps.Marker({
            position: myLatLng,
            map,
            title: 'Contacts',
            icon: {
                url: "/dist/img/icons/pin.svg",
                scaledSize: new google.maps.Size(75, 75)
            }
        });
    } else {
        return false;
    }
}

function initStoresMap(city = 'Chisinau') {
    if (typeof locations === 'undefined') {
        return false;
    }

    const map_stores = new google.maps.Map(document.getElementById("map-stores"), {
        zoom: 12,
        center: new google.maps.LatLng(locations[0][0], locations[0][1])
    });

    setMarkers(map_stores, locations, city);
}

function setMarkers(map, locations) {

    var marker, i, mark_position;
    for (i = 0; i < locations.length; i++) { // Проходимся по нашему массиву с марками

        // Тут вроде и так все понятно
        var lat = locations[i][0];
        var long = locations[i][1];
        var address = locations[i][2];
        var contacts = locations[i][3];
        var name = locations[i][4];
        var image = locations[i][5];
        let contactText = ''
        let locationList = document.querySelector('.list-store');

        // const location = locations[i];

        let sectionNewCode = document.createElement('div');
        sectionNewCode.classList.add('list-store__item');
        sectionNewCode.setAttribute('data-lat', lat)
        sectionNewCode.setAttribute('data-long', long);



        for (let index = 0; index < contacts.length; index++) {
            const contactItem = contacts[index];
            if (index + 1 == contacts.length) {
                contactText += `<a href="tel:${contactItem}">${contactItem} </a>`
            } else {
                contactText += `<a href="tel:${contactItem}">${contactItem} </a>`
            }
        }

        sectionNewCode.innerHTML = `
            <div class="list-store__icon">
                <img src="/dist/img/icons/pin.svg" alt="Icon">
            </div>
            <div class="list-store__body">
                <h6 class="list-store__title">${name}</h6>
                <p class="list-store__address">${address}</p>
                <p class="list-store__phone">${contactText}</p>
            </div>
        `;
        locationList.append(sectionNewCode);

        const content =
            `<div class="marker">
            <div class="marker__image">
                    <img src="${image}" alt="Image">
            </div>
            <div class="marker__body">
                <p class="marker__address">${address}</p>
                <p class="marker__contacts">${contactText}</p>
            </div>
        </div>`;
        mark_position = new google.maps.LatLng(lat, long); // Создаем позицию для отметки


        marker = new google.maps.Marker({ // Что будет содержаться в отметке
            map: map, // К какой карте относиться отметка
            // title: title, // Заголовок отметки
            lat: lat,
            long: long,
            position: mark_position, // Позиция отметки
            animation: google.maps.Animation.DROP, // Анимация
            icon: {
                url: '/dist/img/icons/pin.svg',
                scaledSize: new google.maps.Size(32, 32),
                anchor: new google.maps.Point(16, 16)
            },
        });



        var infowindow = null;

        // marcers_all[i] = marker;

        google.maps.event.addListener(marker, "click", (function (marker, content, infowindow) {
            sectionNewCode.addEventListener('click', () => {
                google.maps.event.trigger(marker, 'click');
            })
            return function () {

                infowindow = new google.maps.InfoWindow();
                infowindow.setContent(content);
                infowindow.open(map, marker);
                map.setZoom(14);
                map.setCenter(new google.maps.LatLng(marker.lat, marker.long));
                // console.log(marker)
                let mapItems = document.querySelectorAll('.list-store__item')
                for (let index = 0; index < mapItems.length; index++) {
                    const mapItem = mapItems[index];
                    if (mapItem.classList.contains('_active')) {
                        mapItem.classList.remove('_active')
                    }

                    if (mapItem.getAttribute('data-lat') == marker.lat && mapItem.getAttribute('data-long') == marker.long) {
                        mapItem.scrollIntoView({
                            block: 'nearest',
                            inline: 'nearest'
                        });
                        mapItem.classList.add('_active')
                    }
                }
                if (document.querySelector('.gm-style-iw-a')) {
                    let div = document.querySelector('.gm-style-iw-a').closest('div');
                    div.remove();
                }
            };
        })(marker, content, infowindow));
    }
}

function detectBrowser() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
        $('.week_select').css('display', 'none');
        $('#week').parent().removeAttr('style');
        return false;
    } else if (userAgent.includes('Firefox')) {
        $('.week_select').css('display', 'none');
        $('#week').parent().removeAttr('style');
        return false;
    } else {
        $('.week_select').removeAttr('style');
        $('#week').parent().css('display', 'none');
        return false;
    }
}

function validateEmailRegex(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function checkAge() {
    if (localStorage.getItem('have_18')) {
        $('#age-check-popup').css('display', 'none');
        $('#overlay').css('display', 'none');
    } else {
        $('#age-check-popup').removeAttr('style');
        $('#overlay').removeAttr('style');
    }
}

$(document).ready(function () {
    checkAge();

    $(document).on('click', '#submit-btn', function () {
        localStorage.setItem('have_18', true);
        checkAge();
    });

    $(document).on('click', '#cancel-btn', function () {
        localStorage.removeItem('have_18');
        checkAge();
        window.location.href = 'https://google.com';
    });

    $("html, body").animate({
        scrollTop: $(window).scrollTop() + 1
    }, 300);

    $(document).on('click', '._tabs-item', function () {
        let currentElement = $(this);
        if (currentElement.hasClass('map')) {
            $('._tabs-item').each(function () {
                $(this).removeClass('_active');

                if ($(this).hasClass('map')) {
                    $(this).addClass('_active');
                }
            });

            $('._tabs-block').each(function () {
                $(this).removeClass('_active');
                if ($(this).hasClass('map')) {
                    $(this).addClass('_active');
                }
            });
        }

        if (currentElement.hasClass('list')) {
            $('._tabs-item').each(function () {
                $(this).removeClass('_active');

                if ($(this).hasClass('list')) {
                    $(this).addClass('_active');
                }
            });

            $('._tabs-block').each(function () {
                $(this).removeClass('_active');
                if ($(this).hasClass('list')) {
                    $(this).addClass('_active');
                }
            });
        }
    });

    if ($('.mini-catalog__table').find('.mini-catalog__item').length <= 3) {
        $('.mini-catalog__table').css('grid-template-rows', '1fr');
    }

    if ($('.about').length) {
        $('.about__description').find('h1').each(function () {
            $(this).addClass('about__title');
            $(this).css('line-height', '28px');
        });
    }

    $(document).on('click', '.product-cigar__name, .product-cigar__image, .product__image, .product__name', function () {
        let currentElement = $(this);
        window.location.href = currentElement.attr('data-href');
    });

    $(document).on('click', '.catalog-menu__nav', function () {
        let currentElement = $(this);
        if (typeof currentElement.attr('data-href') !== 'undefined' && currentElement.attr('data-href') !== '') {
            window.location.href = currentElement.attr('data-href');
        }
    });

    $(document).on('mouseover', '.catalog-menu__nav', function () {
        let currentElement = $(this);
        let elementId = currentElement.attr('data-id');
        let currentLanguage = '';

        $('.catalog-menu__nav').each(function () {
            $(this).removeClass('_active');
        });

        currentElement.addClass('_active');

        $('.language__item').each(function () {
            if ($(this).hasClass('_active')) {
                currentLanguage = $(this).attr('data-lang');
            }
        });

        if (currentLanguage == '') {
            currentLanguage = 'ro';
        }

        $.ajax({
            type: 'GET',
            url: '/catalog_menu',
            data: {
                id: elementId,
                lang: currentLanguage
            },
            success: function (response) {
                $('.catalog-menu__blocks').html('');

                if (typeof JSON.parse(response).html !== 'undefined') {
                    $('.catalog-menu__blocks').html(JSON.parse(response).html);
                }
            }
        });
    });

    if ($('.contacts').length) {
        initMap();
    }

    if ($('.stores').length) {
        initStoresMap();
    }

    if ($('.banner').length) {
        if (typeof countSlides !== 'undefined') {
            let bannerSwiper = new Swiper('.banner__slider', {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 0,
                autoHeight: false,
                speed: 800,
                loop: true,
                pagination: {
                    el: '.banner__paggination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.banner-arrow-next',
                    prevEl: '.banner-arrow-prev',
                },
            });

            bannerSwiper.autoplay.start();
            setTimeout(function () {
                $('.banner-arrow-next').click();
            }, 3000);
        } else {
            new Swiper('.banner__slider', {
                observer: true,
                observeParents: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                autoHeight: false,
                speed: 800,
                loop: true,
                pagination: {
                    el: '.banner__paggination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.banner-arrow-next',
                    prevEl: '.banner-arrow-prev',
                },
            });
        }
    }
});